import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'

// Replymessage
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { t } from '@/@core/libs/i18n/utils'
import { $themeConfig } from '@themeConfig'

export default function useReplymessageList() {
  // Use toast
  const toast = useToast()

  const refReplymessageListTable = ref(null)
  const lineOa = computed(() => store.state.lineapi.lineOa)

  const msgReplymessageList = {
    errorfetchReplymessage: t('Error fetching {module} list', t('Replymessage')),
    id: `${t('Type')} » ${t('ID')}`,
    message: `${t('Reply Message')} » (${t('Reference')} ${t('Chat Message')})`,
    actions: t('Actions'),
  }

  // Table Handlers
  const tableColumns = [
    { key: 'id', sortable: true, label: msgReplymessageList.id },
    { key: 'message', sortable: false, label: msgReplymessageList.message },
    { key: 'actions', label: msgReplymessageList.actions },
  ]

  const filterList = JSON.parse(localStorage.getItem(`${$themeConfig.app.session}-filter-replymessage-list`))
  const perPage = ref((filterList != null && filterList.perPage != null) ? filterList.perPage : 10)
  const totalReplymessages = ref(0)
  // const currentPage = ref((filterList != null && filterList.page != null) ? filterList.page : 1)
  const currentPage = ref(1)
  const perPageOptions = [2, 5, 10, 25, 50, 100]
  const searchQuery = ref((filterList != null && filterList.q != null) ? filterList.q : '')
  const sortBy = ref((filterList != null && filterList.sortBy != null) ? filterList.sortBy : 'id')
  const isSortDirDesc = ref((filterList != null && filterList.sortDesc != null) ? filterList.sortDesc : true)
  const locale = ref('th')

  const dataMeta = computed(() => {
    const localItemsCount = refReplymessageListTable.value ? refReplymessageListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalReplymessages.value,
    }
  })

  const refetchData = () => {
    if (refReplymessageListTable.value !== null) {
      refReplymessageListTable.value.refresh()
    }
  }

  watch([currentPage, perPage, searchQuery, locale], () => {
    refetchData()
  })

  const getListReplymessage = (ctx, callback) => {
    const { id } = JSON.parse(lineOa.value)
    const params = {
      q: searchQuery.value,
      perPage: perPage.value,
      page: currentPage.value,
      sortBy: sortBy.value,
      sortDesc: isSortDirDesc.value,
      language: locale.value,
      lineOaId: id,
    }
    store
      .dispatch('replymessage-store/getListReplymessage', params)
      .then(response => {
        const { list, total } = response.data
        callback(list)
        totalReplymessages.value = total
        localStorage.setItem(`${$themeConfig.app.session}-filter-replymessage-list`, JSON.stringify(params))
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: msgReplymessageList.errorfetchReplymessage,
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        },
        {
          position: 'bottom-right',
        })
      })
  }

  return {
    getListReplymessage,
    tableColumns,
    perPage,
    currentPage,
    totalReplymessages,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    locale,
    refReplymessageListTable,
    filterList,

    refetchData,
  }
}
